import React, { FunctionComponent } from 'react';

import { Text } from 'components/chroma';

import {
  MarketAgreedValue,
  MotorCoverSubSection,
  MotorSection,
  MotorFullPageProps,
} from 'scenes/motor/types';
import {
  getSelectedCoverType,
  getSelectedExcess,
  isMarketValue,
  getAgreedVehicleValue,
  isComprehensiveSelected,
  getSelectedInsuranceType,
  getExtras,
} from 'scenes/motor/selectors';
import { getAvailableExtras } from 'scenes/motor/helpers/OptionalExtras/getAvailableExtras';
import SummaryCard from 'components/SummaryCard';

export const CoverDetailsSummary: FunctionComponent<Pick<
  MotorFullPageProps,
  'funnelState' | 'onEditCoverDetails'
>> = ({ funnelState, onEditCoverDetails }) => {
  const isComprehensive = isComprehensiveSelected(funnelState);
  const extras = getExtras(funnelState);

  return (
    <>
      <SummaryCard
        heading="Cover type"
        onEditClick={() =>
          onEditCoverDetails(
            MotorSection.CoverDetails,
            MotorCoverSubSection.QuotePrice
          )
        }
      >
        <Text>{getSelectedCoverType(funnelState)}</Text>
      </SummaryCard>
      <SummaryCard
        heading="Excess"
        onEditClick={
          isComprehensive
            ? () =>
                onEditCoverDetails(
                  MotorSection.CoverDetails,
                  MotorCoverSubSection.MotorExcess
                )
            : undefined
        }
      >
        <Text>{`$${getSelectedExcess(funnelState).amount}`}</Text>
        <Text>
          Additional excesses for young or inexperienced drivers may apply.
        </Text>
      </SummaryCard>
      {isComprehensive && (
        <SummaryCard
          heading="Insured value"
          onEditClick={() =>
            onEditCoverDetails(
              MotorSection.CoverDetails,
              MotorCoverSubSection.MarketAgreedValue
            )
          }
        >
          <Text>
            {isMarketValue(funnelState)
              ? MarketAgreedValue.Market
              : MarketAgreedValue.Agreed}
          </Text>
          {!isMarketValue(funnelState) && (
            <Text>{`$${getAgreedVehicleValue(funnelState)}`}</Text>
          )}
        </SummaryCard>
      )}
      <SummaryCard
        heading="Optional extras"
        onEditClick={() =>
          onEditCoverDetails(
            MotorSection.CoverDetails,
            MotorCoverSubSection.OptionalExtras
          )
        }
      >
        {extras.length > 0 ? (
          <Text>
            {extras.map((oe) => (
              <React.Fragment key={oe}>
                {
                  getAvailableExtras(
                    getSelectedInsuranceType(funnelState)
                  ).find((extra) => extra.code === oe)?.label
                }
                <br />
              </React.Fragment>
            ))}
          </Text>
        ) : (
          <Text>None</Text>
        )}
      </SummaryCard>
    </>
  );
};

export default CoverDetailsSummary;
